module.exports = __webpack_public_path__ + "img/raw1.4b795bf6.png";